import "../Home/Home.css";
import PageHero from "../../components/PageHero/PageHero";
import AboutBlock from "../../components/Blocks/AboutBlock/AboutBlock";
import CompetenciesBlock from "../../components/Blocks/CompetenciesBlock/CompetenciesBlock";
import ProjectDetailBlock from "../../components/Blocks/ProjectDetailBlock/ProjectDetailBlock";
import VisionMissionBlock from "../../components/Blocks/VisionMissionBlock/VisionMissionBlock";
import StrengthsBlock from "../../components/Blocks/StrengthsBlock/StrengthsBlock";
import HSEBlock from "../../components/Blocks/HSEBlock/HSEBlock";
import CapabilityBlock from "../../components/Blocks/CapabilityBlock/CapabilityBlock";
import ExperienceHighlightBlock from "../../components/Blocks/ExperienceHighlightBlock/ExperienceHighlightBlock";
import GroupStrengthBlock from "../../components/Blocks/GroupStrengthBlock/GroupStrengthBlock";
import ExecutionApproachBlock from "../../components/Blocks/ExecutionApproachBlock/ExecutionApproachBlock";

function Projects({ content, loading }) {
  if (loading || !content) {
    return <div className="home-page">Loading...</div>;
  }

  return (
    <div className="home-page">

      <PageHero
        title={content.pageHero?.projects?.title}
        media={content.pageHero?.projects?.media}
      />

      <CompetenciesBlock
        title={content.block4?.title}
        subtitle={content.block4?.subtitle}
        competencies={content.block4?.competencies}
      />

      <AboutBlock
        smallTitle={content.block2?.smallTitle}
        mainTitle={content.block2?.mainTitle}
        description={content.block2?.description}
        image={content.block2?.image}
      />

      <ProjectDetailBlock
        title={content.block6?.title}
        location={content.block6?.location}
        capacity={content.block6?.capacity}
        timeline={content.block6?.timeline}
        scope={content.block6?.scope}
        image={content.block6?.image}
        locationIcon={content.block6?.locationIcon}
        capacityIcon={content.block6?.capacityIcon}
        timeIcon={content.block6?.timeIcon}
        epcIcon={content.block6?.epcIcon}
        story={content.block6?.story}
      />

      <VisionMissionBlock
        title={content.block7?.title}
        cards={content.block7?.cards}
      />

      <StrengthsBlock
        title={content.block9?.title}
        items={content.block9?.items}
      />

      <HSEBlock
        smallTitle={content.block10?.smallTitle}
        title={content.block10?.title}
        description={content.block10?.description}
        image={content.block10?.image}
        checkpoints={content.block10?.checkpoints}
      />

      <CapabilityBlock
        badge={content.block11?.badge}
        title={content.block11?.title}
        description={content.block11?.description}
        highlight={content.block11?.highlight}
        capabilities={content.block11?.capabilities}
      />

      <ExperienceHighlightBlock
        backgroundImage={content.block12?.backgroundImage}
        title={content.block12?.title}
        mainValue={content.block12?.mainValue}
        mainDescription={content.block12?.mainDescription}
        features={content.block12?.features}
      />

      <GroupStrengthBlock
        title={content.block13?.title}
        intro={content.block13?.intro}
        sisterCompany={content.block13?.sisterCompany}
        regions={content.block13?.regions}
        stats={content.block13?.stats}
        footer={content.block13?.footer}
      />

      <ExecutionApproachBlock
        title={content.block14?.title}
        pillars={content.block14?.pillars}
      />

    </div>
  );
}

export default Projects;
